import { useNavigate } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { useAuthContext } from '../auth/useAuthContext';
import { PATH_ADMIN } from '../routes/paths';
import { hasSessionAdmin, logOutOfOtherUser } from '../utils/mrr/emulator/signInAsOtherUser';
import LoadingScreen from '../components/loading-screen/LoadingScreen';
import { dispatch } from '../redux/store';
import { apiSlice } from '../redux/rtkQuery/apiSlice';
import { WritePostLoginPath } from '../config-global';
import { Roles } from '../utils/mrr/userConstants';

export default function LogOutPage() {
    const { user, logout, isInitialized, setAdminSessionChanging } = useAuthContext();
    const navigate = useNavigate();
    // the restored admin arrives as a new `user`, which re-runs this effect; it must not log them out
    const adminRestoreStarted = useRef(false);
    useEffect(() => {
        //[[USER LOGOUT]]
        // wipe the RTK Query cache
        dispatch(apiSlice.util.resetApiState());

        //NOTE: This conditional previously checked "isInitialized", which comes from
        //		authContext. We've seen it to be redundant, so far, but it's something
        //		to keep in mind.
        if (!user) {
            navigate('/', { replace: true });
            return;
        }
        if (adminRestoreStarted.current) {
            return;
        }
        if (hasSessionAdmin()) {
            //NOTE: No signOut here. The restore endpoint requires the current session, and
            //		signing in with the admin's custom token replaces it.
            adminRestoreStarted.current = true;
            setAdminSessionChanging(true);
            logOutOfOtherUser(user.id).then(() => {
                navigate(PATH_ADMIN.user.list, { replace: true });
            }).catch(() => {
                setAdminSessionChanging(false);
                navigate(WritePostLoginPath(Roles.User), { replace: true });
            });
            return;
        }
        logout();
    }, [logout, navigate, user, isInitialized, setAdminSessionChanging]);
    return <LoadingScreen />;
}
